import { useContext } from "react";
import { Link } from "react-router-dom";
import { ScrollContext } from "../../Context/ScrollContext";
import { ThemeContext } from "../../Context/ThemeContext";
import SingleProject from "./SingleProject";

const PROJECTS = {
  projectArr: ["savvyard", "spytechwear"],
  savvyard: {
    imgSrc: "/images/savvyard.png",
    imgDesc: "mobile version of project: ",
    title: "Savvyard",
  },
  spytechwear: {
    imgSrc: "/images/spytechwear.png",
    imgDesc: "mobile version of project: ",
    title: "Spy Tech Wear",
  },
};
const Project = () => {
  const { ProjectRef } = useContext(ScrollContext);
  const { setPath } = useContext(ThemeContext);

  return (
    <div id="project" className="main-content-div" ref={ProjectRef}>
      <h1>Projects</h1>

      <div className="projects-div">
        {PROJECTS.projectArr.map((key) => {
          const { imgSrc, imgDesc, title } = PROJECTS[key];
          return (
            <Link
              to={`/project/${key}`}
              onClick={() => setPath(`/project/${key}`)}
              key={key}
              className="projectLink"
              style={{ background: "var(--bg-highlight-color)" }}
            >
              <img src={imgSrc} alt={imgDesc + key} />
              <h3 style={{ background: "transparent" }}>{title}</h3>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Project;
